import logoNoronCar from '../Images/logo.png';
import "./Register.css";
import loginLogo from '../Images/logoWeb.png';
import AddImage from '../Images/AddImage.png';
import React, { useEffect, useState, useRef } from "react";
import config from "../config.json";
import { Link, useNavigate } from 'react-router-dom';
import http from "../Services/httpService";
import service from "../Services/services";
import { toast } from "react-toastify";

export default function Register() {
    const navigate = useNavigate();
    const [isPosting, setIsPosting] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [shobehList, setShobehList] = useState([]);
    const [previewMovafegh, setPreviewMovafegh] = useState(null);

    const [form, setForm] = useState({
        codeMeli: "",
        mobile: "",
        mostamariCode: "",
        name: "",
        family: "",
        nameFather: "",
        code: "",
        birthDay: "",
        telfix: "",
        address: "",
        shobeh: "",
        movafeghPic: null,
        company: config?.Company || "",
        version: config?.Version || "1.0.0",
        year: config?.Year || ""
    });

    const formRef = useRef(null);
    const picMovafegh = useRef(null);

    useEffect(() => {
        const jwt = http.getLocalJwt();
        if (jwt && jwt !== "") {
            navigate('/main');
        }
        doLoadShobehList();
    }, [navigate]);

    const doLoadShobehList = async () => {
        setIsLoading(true);
        try {
            const { data } = await service.ShobehListPublic({
                from: 0,
                pageSize: 100,
                where: "",
                order: "",
            });
            setIsLoading(false);
            if (data.errorCode !== 0) {
                toast.error(data.message, { theme: "colored" });
                return;
            }
            setShobehList(data.payload.list || []);
        } catch (err) {
            setIsLoading(false);
        }
    };

    const handleFileChange = (e, fieldName) => {
        const file = e.target.files?.[0];
        if (!file) return;

        // خواندن و ایجاد پیش‌نمایش تصویر
        const reader = new FileReader();
        reader.onload = () => {
            setPreviewMovafegh(reader.result);
        };
        reader.readAsDataURL(file);

        setForm(prev => ({ ...prev, [fieldName]: file }));
    };

    const handleRemoveImage = (e) => {
        e.stopPropagation();
        setPreviewMovafegh(null);
        setForm(prev => ({ ...prev, movafeghPic: null }));
        if (picMovafegh.current) picMovafegh.current.value = "";
    };

    const handlePosting = async (e) => {
        e.preventDefault();
        const forms = formRef.current;
        if (forms.checkValidity() === false) {
            toast.error('لطفاً فیلدهای الزامی ستاره‌دار را به درستی تکمیل فرمایید', { theme: "colored" });
            forms.classList.add('was-validated');
            return;
        }

        if (!form.movafeghPic) {
            toast.warning('لطفاً تصویر حکم بازنشستگی را بارگذاری نمایید', { theme: "colored" });
            return;
        }

        setIsPosting(true);
        try {
            const { data } = await service.OzveRegister(form);
            setIsPosting(false);
            if (data.errorCode !== 0) {
                toast.error(data.message, { theme: "colored" });
                return;
            }
            toast.dark('ثبت نام با موفقیت انجام شد. لطفاً وارد سایت شوید.');
            navigate(`/login`);
        } catch (err) {
            if (err.response?.data?.errorCode && err.response.data.errorCode !== 0) {
                toast.error(err.response.data.message, { theme: "colored" });
            }
            setIsPosting(false);
        }
    };

    return (
        <div className="container-fluid bg-light min-vh-100 py-4 px-2 px-md-3 d-flex align-items-center justify-content-center" dir="rtl">
            <div className="container" style={{ maxWidth: '960px' }}>
                <div className="card shadow border-0 rounded-4 p-3 p-md-5 bg-white">

                    {/* سربرگ و لوگو */}
                    <div className="text-center mb-4">
                        <img 
                            src={loginLogo} 
                            className="img-fluid mb-2" 
                            alt="لوگو کانون" 
                            style={{ maxHeight: '75px', objectFit: 'contain' }}
                        />
                        <h1 className="h4 fw-bold text-dark mb-1">
                            🏛️ ثبت نام کانون بازنشستگان استان همدان
                        </h1>
                        <p className="text-secondary small mb-0">
                            لطفاً مشخصات فردی و مدارک خواسته شده را با دقت ثبت نمایید
                        </p>
                    </div>

                    <form ref={formRef} className="needs-validation" onSubmit={handlePosting} noValidate>

                        {/* بخش اول: اطلاعات شناسنامه‌ای و هویتی */}
                        <div className="mb-4">
                            <div className="d-flex align-items-center gap-2 pb-2 mb-3 border-bottom text-dark">
                                <span className="fs-5" aria-hidden="true">👤</span>
                                <span className="fw-bold">مشخصات هویتی و پرسنلی</span>
                            </div>

                            <div className="row g-3">
                                <div className="col-12 col-sm-6 col-md-4">
                                    <label className="form-label small fw-semibold text-secondary">کد ملی <span className="text-danger">*</span></label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-light border-end-0 text-muted" aria-hidden="true">🪪</span>
                                        <input
                                            type="tel"
                                            inputMode="numeric"
                                            className="form-control border-start-0 text-end"
                                            placeholder="۱۰ رقم بدون خط تیره"
                                            required
                                            maxLength="10"
                                            value={form.codeMeli || ""}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            name="codeMeli"
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-sm-6 col-md-4">
                                    <label className="form-label small fw-semibold text-secondary">شماره مستمری <span className="text-danger">*</span></label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-light border-end-0 text-muted" aria-hidden="true">💳</span>
                                        <input
                                            type="tel"
                                            inputMode="numeric"
                                            className="form-control border-start-0 text-end"
                                            placeholder="شماره مستمری"
                                            required
                                            value={form.mostamariCode || ""}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            name="mostamariCode"
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-sm-6 col-md-4">
                                    <label className="form-label small fw-semibold text-secondary">شماره شناسنامه <span className="text-danger">*</span></label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-light border-end-0 text-muted" aria-hidden="true">🔢</span>
                                        <input
                                            type="tel"
                                            inputMode="numeric"
                                            className="form-control border-start-0 text-end"
                                            placeholder="شماره شناسنامه"
                                            required
                                            value={form.code || ""}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            name="code"
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-sm-6 col-md-4">
                                    <label className="form-label small fw-semibold text-secondary">نام <span className="text-danger">*</span></label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-light border-end-0 text-muted" aria-hidden="true">✏️</span>
                                        <input
                                            type="text"
                                            className="form-control border-start-0"
                                            placeholder="نام"
                                            required
                                            value={form.name || ""}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            name="name"
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-sm-6 col-md-4">
                                    <label className="form-label small fw-semibold text-secondary">نام خانوادگی <span className="text-danger">*</span></label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-light border-end-0 text-muted" aria-hidden="true">✏️</span>
                                        <input
                                            type="text"
                                            className="form-control border-start-0"
                                            placeholder="نام خانوادگی"
                                            required
                                            value={form.family || ""}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            name="family"
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-sm-6 col-md-4">
                                    <label className="form-label small fw-semibold text-secondary">نام پدر <span className="text-danger">*</span></label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-light border-end-0 text-muted" aria-hidden="true">👨</span>
                                        <input
                                            type="text"
                                            className="form-control border-start-0"
                                            placeholder="نام پدر"
                                            required
                                            value={form.nameFather || ""}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            name="nameFather"
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-sm-6 col-md-4">
                                    <label className="form-label small fw-semibold text-secondary">تاریخ تولد <span className="text-danger">*</span></label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-light border-end-0 text-muted" aria-hidden="true">📅</span>
                                        <input
                                            type="text"
                                            className="form-control border-start-0 text-end"
                                            placeholder="مثال: ۱۳۳۵/۰۴/۱۵"
                                            required
                                            value={form.birthDay || ""}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            name="birthDay"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* بخش دوم: اطلاعات ارتباطی و مکانی */}
                        <div className="mb-4">
                            <div className="d-flex align-items-center gap-2 pb-2 mb-3 border-bottom text-dark">
                                <span className="fs-5" aria-hidden="true">📞</span>
                                <span className="fw-bold">اطلاعات تماس و سکونت</span>
                            </div>

                            <div className="row g-3">
                                <div className="col-12 col-sm-6 col-md-4">
                                    <label className="form-label small fw-semibold text-secondary">شماره موبایل <span className="text-danger">*</span></label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-light border-end-0 text-muted" aria-hidden="true">📱</span>
                                        <input
                                            type="tel"
                                            inputMode="numeric"
                                            className="form-control border-start-0 text-end"
                                            placeholder="۰۹xxxxxxxxx"
                                            required
                                            maxLength="11"
                                            value={form.mobile || ""}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            name="mobile"
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-sm-6 col-md-4">
                                    <label className="form-label small fw-semibold text-secondary">تلفن ثابت <span className="text-danger">*</span></label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-light border-end-0 text-muted" aria-hidden="true">☎️</span>
                                        <input
                                            type="tel"
                                            inputMode="numeric"
                                            className="form-control border-start-0 text-end"
                                            placeholder="همراه با پیش‌شماره"
                                            required
                                            value={form.telfix || ""}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            name="telfix"
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-sm-6 col-md-4">
                                    <label className="form-label small fw-semibold text-secondary">
                                        شهرستان <span className="text-danger">*</span>
                                        {isLoading && (
                                            <span className="spinner-border spinner-border-sm text-primary ms-1" role="status">
                                                <span className="visually-hidden">در حال دریافت...</span>
                                            </span>
                                        )}
                                    </label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-light border-end-0 text-muted" aria-hidden="true">🏛️</span>
                                        <select
                                            className="form-select border-start-0"
                                            required
                                            value={form.shobeh || ""}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            name="shobeh"
                                        >
                                            <option value="">انتخاب شهرستان...</option>
                                            {shobehList.map((x) => (
                                                <option key={x.id} value={x.id}>{x.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div className="col-12">
                                    <label className="form-label small fw-semibold text-secondary">آدرس محل سکونت <span className="text-danger">*</span></label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-light border-end-0 text-muted align-items-start pt-2" aria-hidden="true">📍</span>
                                        <textarea
                                            rows="2"
                                            className="form-control border-start-0"
                                            placeholder="آدرس دقیق، خیابان، کوچه، پلاک"
                                            required
                                            value={form.address || ""}
                                            onChange={e => http.handleChange(e, form, setForm)}
                                            name="address"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* بخش سوم: بارگذاری مدارک */}
                        <div className="mb-4">
                            <div className="d-flex align-items-center gap-2 pb-2 mb-3 border-bottom text-dark">
                                <span className="fs-5" aria-hidden="true">📎</span>
                                <span className="fw-bold">بارگذاری مدارک هویتی</span>
                            </div>

                            <div className="row g-3 justify-content-center">
                                <div className="col-12 col-md-6">
                                    <input
                                        accept="image/*"
                                        className="d-none"
                                        type="file"
                                        onChange={(e) => handleFileChange(e, "movafeghPic")}
                                        ref={picMovafegh}
                                    />
                                    
                                    <div
                                        className="card border-2 border-dashed bg-light text-center p-4 d-flex flex-column align-items-center justify-content-center position-relative overflow-hidden cursor-pointer"
                                        onClick={() => picMovafegh.current.click()}
                                        style={{
                                            minHeight: '200px',
                                            cursor: 'pointer',
                                            backgroundImage: previewMovafegh ? `url(${previewMovafegh})` : 'none',
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat'
                                        }}
                                    >
                                        {!previewMovafegh ? (
                                            <>
                                                <img 
                                                    src={AddImage} 
                                                    alt="بارگذاری" 
                                                    className="img-fluid mb-2" 
                                                    style={{ width: '48px', height: '48px', objectFit: 'contain' }} 
                                                />
                                                <span className="fw-bold text-dark small">تصویر حکم بازنشستگی <span className="text-danger">*</span></span>
                                                <span className="text-muted small mt-1">جهت انتخاب یا تغییر عکس کلیک نمایید</span>
                                            </>
                                        ) : (
                                            <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex flex-column align-items-center justify-content-center p-3">
                                                <span className="badge bg-success mb-2 px-3 py-2 fs-6">✓ تصویر انتخاب شد</span>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-light shadow-sm d-inline-flex align-items-center gap-1"
                                                    onClick={handleRemoveImage}
                                                >
                                                    <span>🗑️</span>
                                                    <span>حذف تصویر</span>
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* دکمه ارسال ثبت نام */}
                        <div className="mt-4 text-center">
                            <button
                                type="submit"
                                className="btn btn-primary w-100 py-3 rounded-3 d-flex align-items-center justify-content-center gap-2 shadow-sm"
                                disabled={isPosting}
                            >
                                {isPosting ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        <span>در حال ارسال اطلاعات...</span>
                                    </>
                                ) : (
                                    <>
                                        <span className="fw-bold">ثبت نام در کانون</span>
                                        <span aria-hidden="true">✓</span>
                                    </>
                                )}
                            </button>
                        </div>

                    </form>

                    {/* دکمه بازگشت به ورود */}
                    <div className="mt-4 pt-3 border-top text-center">
                        <span className="text-secondary small me-2">قبلاً در کانون ثبت‌نام کرده‌اید؟</span>
                        <Link 
                            to="/login" 
                            className="btn btn-outline-secondary btn-sm rounded-pill d-inline-flex align-items-center gap-2 text-decoration-none px-3 py-1 shadow-sm mt-2 mt-sm-0"
                        >
                            <img 
                                src={logoNoronCar} 
                                className="rounded-circle shadow-sm" 
                                style={{ width: '22px', height: '22px', objectFit: 'contain' }} 
                                alt="ورود" 
                            />
                            <span className="fw-semibold">ورود به سامانه</span>
                            <span aria-hidden="true">➜</span>
                        </Link>
                    </div>

                </div>
            </div>
        </div>
    );
}
